<div style="width: 100%;">
	<mat-form-field mat-form-field fxFlex="30" fxFlex.md="30" fxFlex.xs="50">
		<mat-label>País</mat-label>
		<mat-select [(value)]="obj_selectedCountryCode" (selectionChange)="fn_onCountryChange()">
			<mat-option *ngFor="let country of obj_countries" [value]="country.code">
			{{ country.name }} (+{{ country.dialCode }})
			</mat-option>
		</mat-select>
	</mat-form-field>
	
	<mat-form-field mat-form-field fxFlex="70" fxFlex.md="70" fxFlex.xs="50" 
	[class.mat-form-field-invalid]="!this.vc_phoneNumberValid && (phone.touched || phone.dirty)">
		<mat-label>Teléfono</mat-label>
		<input 
			type="text" 
			matInput 
			#phone="ngModel" 
			name="phone" 
			[(ngModel)]="this.vc_phoneNumber" 
			(ngModelChange)="fn_onPhoneNumberChange()" 
			(blur)="fn_emitPhoneNumber(this.vc_phoneNumber)"
			maxlength="10"
			required
		>
		<mat-hint 
			class="error"
			*ngIf="!this.vc_phoneNumberValid && (phone.touched || phone.dirty)">
				Número inválido
		</mat-hint>

		<!-- <mat-error *ngIf="!this.phoneNumberValid && (phone.touched || phone.dirty)">
			Invalid phone number
		</mat-error> -->
	</mat-form-field>
</div>

